"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PharmacyHeader = void 0;
const ui_1 = require("../../../../../../../../../../client/components/ui");
const store_1 = require("../../../../../../../../../../client/modules/reporting/store");
const store_2 = require("../../../../../../../../../../client/modules/users/store");
const mobx_1 = require("mobx");
const mobx_react_1 = require("mobx-react");
const React = require("react");
const react_1 = require("react");
let PharmacyHeader = class PharmacyHeader extends react_1.Component {
    constructor() {
        super(...arguments);
        this.userId = 0;
        this.handleChangeUser = (id) => {
            this.userId = Number(id);
        };
    }
    componentWillMount() {
        var _a, _b;
        this.userId = (_b = (_a = store_2.usersStore.user) === null || _a === void 0 ? void 0 : _a.value) === null || _b === void 0 ? void 0 : _b.id;
        this.handleChangeUser(String(this.userId));
    }
    render() {
        const { label = "Search", title, withDatePicker } = this.props;
        return (React.createElement("div", null,
            React.createElement("div", { style: { display: "flex", flexDirection: "row" } }, title && (React.createElement("div", { className: "filter-bar__title", style: { margin: "10px" } },
                React.createElement("div", { className: "filter-bar__title-text" }, title)))),
            store_1.reportsStore.showLoader ? React.createElement(ui_1.UiLoadingIndicator, null) : null));
    }
};
__decorate([
    mobx_1.observable
], PharmacyHeader.prototype, "userId", void 0);
PharmacyHeader = __decorate([
    mobx_react_1.observer
], PharmacyHeader);
exports.PharmacyHeader = PharmacyHeader;



//////////////////
// WEBPACK FOOTER
// ./src/client/modules/reporting/modules/reporting-list/components/report-container/pharmacy/components/pharmacy-header/pharmacy-header.tsx
// module id = 3986
// module chunks = 0